import { createMuiTheme, Theme } from '@material-ui/core';

export interface ExtendedTheme extends Theme {
  container: string;
}

const theme: ExtendedTheme = {
  ...createMuiTheme({
    colors: {
      brandPrimary: '#009090',
      backgroundColor: '#F1F2F5',
      navigation: '#1C2647',
      section: '#005C69',
      unselected: '#597982',
      selected: '#F37A21',
      profileIcons: '#ACBCC0',
      outlines: '#D5DDE0',
      tabs: '#26325F',
      border: '#DCDEE5',
      icon: '#747C99',
      primary: '#01B3C5',
    },
    palette: {
      primary: {
        main: '#FF6C00',
        contrastText: '#FFFFFF',
      },
      secondary: {
        main: '#00AD8D',
      },
      error: {
        main: '#F8221A',
      },
      text: {
        primary: '#263245',
        secondary: '#515B6A',
      },
      background: {
        default: '#FFF',
      },
      menuAction: {
        active: '#FFFFFF',
        hover: '#01B3C5',
        selected: '#01B3C5',
      },
      tabs: {
        active: '#FFFFFF',
        selected: 'rgba(1, 179, 197, 0.08)',
        hover: '#01B3C5',
        unselected: '#26325F',
      },
      breadcrumbs: {
        active: '#018694',
        hover: '#01B3C5',
        selected: '#515B6A',
      },
      icons: {
        default: '#747C99',
        delete: '#F8221A',
        statusOk: '#00AD8D',
        menu: '#FFF',
        send: '#7CAF42',
      },
      cancelAction: {
        background: '#F9FAFB',
        color: '#26325F',
      },
      switch: {
        track: {
          background: '#DCDEE5',
          opacity: 1,
        },
        color: '#F1F2F5',

      },
      input: {
        borderBottomColor: '#DCDEE5',
      },
      disabledInput: {
        color: '#747C99',
      },
      table: {
        border: '#DCDEE5',
        background: '#FFF',
        header: {
          background: '#F9FAFB',
          hover: '#01B3C5',
          color: '#26325F',
        },
        row: {
          hover: 'rgba(1, 179, 197, 0.08)',
        },
      },
      filter: {
        color: '#747C99',
        hover: '#01B3C5',
      },
      navBar: {
        background: '#1C2647',
        color: '#fff',
        hover: '#01B3C5',
        active: '#01B3C5',
      },
      publicNavBar: {
        background: '#FFF',
        color: '#515B6A',
        hover: '#01B3C5',
        active: '#01B3C5',
      },
      link: {
        color: '#01B3C5',
      },
      disabledButton: {
        color: '#FFF !important',
        background: '#DCDEE5 !important',
      },
      userBarMenu: {
        color: '#FFF',
      },
      filterChip: {
        color: '#747C99',
        active: '#018694',
        hover: '#01B3C5',
      },
      buttonAction: {
        color: '#FFF',
        background: '#FF6C00',
        overlay: 'rgba(0, 0, 0, 0.1)',
      },
      buttonSingle: {
        color: '#01B3C5',
        hover: 'rgba(1,179,197,0.1)',
      },
      deleteButton: {
        color: '#F8221A',
        background: '#FFF',
        hover: 'rgba(248,34,26,0.1)',
      },
      expansionPanelSummary: {
        borderColor: '#DCDEE5',
        background: '#F9FAFB',
        color: '#26325F',
      },
      studio: {
        background: '#263245',
        borderColor: '#747C99',
        action: '#747C99',
        disabledAction: '#757c99',
        guide: 'rgba(149,255,255,0.05)',
        guideBorder: 'rgba(255,255,255,0.5)',
        track: 'rgba(81,91,106,0.5)',
      },
      progress: {
        background: '#DCDEE5',
        backgroundValue: '#01B3C5',
      },
      player: {
        trackBackground: 'rgba(81,91,106,0.5)',
        trackValueBackground: '#01B3C5',
      },
      tooltip: {
        color: '#FFF',
        background: '#515B6A',
      },
      imageInstruction: {
        background: 'rgba(131, 36, 178, 0.1)',
        border: 'rgba(131, 36, 178, 0.5)',
        icon: '#8324B2',
      },
      textInstruction: {
        background: 'rgba(239, 296, 0, 0.1)',
        actionBorder: 'rgba(239, 296, 0, 0.5)',
        border: '#EFC400',
        icon: '#EFC400',
      },
      noteInstruction: {
        background: '#F1F2F5',
        border: '#DCDEE5',
        icon: '#DCDEE5',
      },
      videoInstruction: {
        background: 'rgba(0, 173, 141, 0.1)',
        border: 'rgba(0, 173, 141, 0.5)',
        icon: '#00AD8D',
      },
      titleInstruction: {
        background: 'rgba(28, 38, 71, 0.1)',
        border: 'rgba(28, 38, 71, 0.5)',
        icon: '#1C2647',
      },
    },
  }),
  container: '1280px',
};

export default theme;
